export const NotFound = () => {
    return <div className="notFound">
      <h1>Error 404</h1>
      <p>This page does not exist.</p>
    </div>
}
  
